import { DEVICE_CLASSIFICATION_VERSION } from '@playcastdotio/Messaging';

export interface DeviceFacts {
  userAgent: string;
  platform?: string;
  maxTouchPoints?: number;
  userAgentDataMobile?: boolean;
  /** Physical CSS screen size survives the browser's desktop-site layout mode. */
  screenWidth?: number;
  screenHeight?: number;
  touchCapable?: boolean;
}

/** Pure device classification; optional network/decoder probes cannot erase it. */
export class DeviceMetadataManager {
  classify(facts: DeviceFacts): {
    deviceClassificationVersion: 1;
    isMobile: boolean;
    isApple: boolean;
    isFirefox: boolean;
  } {
    const ua = facts.userAgent.toLowerCase();
    const platform = (facts.platform ?? '').toLowerCase();
    const touch = (facts.maxTouchPoints ?? 0) > 0 || facts.touchCapable === true;
    const apple = /iphone|ipad|ipod|macintosh|mac os x/.test(ua) || /iphone|ipad|ipod|mac/.test(platform);
    const handheld = /iphone|ipad|ipod|android|blackberry|windows phone|tablet|playbook|silk/.test(ua);
    const phoneScreen = [facts.screenWidth, facts.screenHeight]
      .every((dimension) => typeof dimension === 'number' && Number.isFinite(dimension) && dimension > 0)
      && Math.min(facts.screenWidth!, facts.screenHeight!) <= 768;
    return {
      deviceClassificationVersion: DEVICE_CLASSIFICATION_VERSION,
      isMobile: facts.userAgentDataMobile === true || handheld || (touch && (apple || phoneScreen)),
      isApple: apple,
      isFirefox: /firefox|fxios/.test(ua),
    };
  }
}
